// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DraftContainer {


    p {
        text-align: justify;
    }


    ol {
        li {
            margin: 10px 0px;
            text-align: justify;
        }
    }



    table {
        width: 90%;
        border: 1px solid black;
        border-radius: 0% !important;

        tr,
        th,
        td {
            border-radius: 0% !important;
            border: 1px solid black;

        }

        thead {
            tr {
                th {
                    padding: 10px 10px;
                }
            }
        }

        tbody {
            tr {
                td {
                    border: 1px solid black !important;
                }
            }
        }
    }

    .tableContainer {
        width: 98%;
    }
}


.tableDesign {
    border: 1px solid #98BDED;

    table {
        width: 100%;
        border-collapse: collapse;
        /* border: 1px solid #AFD1F6 !important; */

        thead {
            tr {
                color: 'white';
                height: '3.5rem';
                /* border: 1px solid #AFD1F6 !important; */

                th {
                    border: 1px solid #AFD1F6 !important;
                }
            }
        }

        tbody {
            tr {
                color: 'white';
                height: '3.5rem';
                border: 1px solid #AFD1F6 !important;

                td {
                    border: 1px solid #AFD1F6 !important;
                }
            }
        }


    }
}`, "",{"version":3,"sources":["webpack://./src/Components/admin/pages/ProjectManagement/grdraftreceipt.css"],"names":[],"mappings":"AAAA;;;IAGI;QACI,mBAAmB;IACvB;;;IAGA;QACI;YACI,gBAAgB;YAChB,mBAAmB;QACvB;IACJ;;;;IAIA;QACI,UAAU;QACV,uBAAuB;QACvB,4BAA4B;;QAE5B;;;YAGI,4BAA4B;YAC5B,uBAAuB;;QAE3B;;QAEA;YACI;gBACI;oBACI,kBAAkB;gBACtB;YACJ;QACJ;;QAEA;YACI;gBACI;oBACI,kCAAkC;gBACtC;YACJ;QACJ;IACJ;;IAEA;QACI,UAAU;IACd;AACJ;;;AAGA;IACI,yBAAyB;;IAEzB;QACI,WAAW;QACX,yBAAyB;QACzB,0CAA0C;;QAE1C;YACI;gBACI,cAAc;gBACd,gBAAgB;gBAChB,0CAA0C;;gBAE1C;oBACI,oCAAoC;gBACxC;YACJ;QACJ;;QAEA;YACI;gBACI,cAAc;gBACd,gBAAgB;gBAChB,oCAAoC;;gBAEpC;oBACI,oCAAoC;gBACxC;YACJ;QACJ;;;IAGJ;AACJ","sourcesContent":[".DraftContainer {\n\n\n    p {\n        text-align: justify;\n    }\n\n\n    ol {\n        li {\n            margin: 10px 0px;\n            text-align: justify;\n        }\n    }\n\n\n\n    table {\n        width: 90%;\n        border: 1px solid black;\n        border-radius: 0% !important;\n\n        tr,\n        th,\n        td {\n            border-radius: 0% !important;\n            border: 1px solid black;\n\n        }\n\n        thead {\n            tr {\n                th {\n                    padding: 10px 10px;\n                }\n            }\n        }\n\n        tbody {\n            tr {\n                td {\n                    border: 1px solid black !important;\n                }\n            }\n        }\n    }\n\n    .tableContainer {\n        width: 98%;\n    }\n}\n\n\n.tableDesign {\n    border: 1px solid #98BDED;\n\n    table {\n        width: 100%;\n        border-collapse: collapse;\n        /* border: 1px solid #AFD1F6 !important; */\n\n        thead {\n            tr {\n                color: 'white';\n                height: '3.5rem';\n                /* border: 1px solid #AFD1F6 !important; */\n\n                th {\n                    border: 1px solid #AFD1F6 !important;\n                }\n            }\n        }\n\n        tbody {\n            tr {\n                color: 'white';\n                height: '3.5rem';\n                border: 1px solid #AFD1F6 !important;\n\n                td {\n                    border: 1px solid #AFD1F6 !important;\n                }\n            }\n        }\n\n\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
